import React, { useState, useEffect } from 'react';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { joinByKeys } from "../../Js/Common";
import { makeStyles } from '@material-ui/core/styles';

const ClasswiseTopLearners = (props) => {
    const styles = useStyles();
    const { classWiseLearnersData } = props;

    // Load Dynamic Image
    const loadImage = (rank) => {
        switch (rank) {
            case 1:
                return require('../../assets/gold_cup.png');
            case 2:
                return require('../../assets/silver_cup.png');
            case 3:
                return require('../../assets/copper_cup.png');
            case "default":
                return require('../../assets/copper_cup.png');
        }
    }    
    return (
        <>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align="right" sx={{ color: '#DB8829', fontSize: '1rem', fontWeight: '700', padding: '1px',pl:6, '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                            Rank
                        </TableCell>
                        <TableCell align="right" sx={{ color: '#DB8829', fontSize: '1rem', fontWeight: '700', padding: '1px', py: 1.5, '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                            Learner Name
                        </TableCell>
                        <TableCell align="center" sx={{ color: '#DB8829', fontSize: '1rem', fontWeight: '700', padding: '1px', py: 1.5, '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                            Percentage
                        </TableCell>
                    </TableRow>
                </TableHead>
                </Table>
                <div style={{height:'65vh', overflow:'auto'}} className={styles.scrollBar}>
                {classWiseLearnersData && classWiseLearnersData.data && (
                    <Table style={{tableLayout: 'fixed'}}>
                    <TableBody>
                        {classWiseLearnersData.data.map((learnerData, learnerIndex) => {
                            return (
                                <TableRow key={`learnerUsage_${learnerIndex}`} sx={{ py: 0, cursor: "pointer"}} onClick={() => { props.handleNavigate(learnerData) }}>
                                    <TableCell align="justify" sx={{ color: '#DB8829', fontSize: '0.75rem', fontWeight: '500', padding: '10px', '@media (min-width: 1636px)': { fontSize: '1.1rem' } }}>
                                        <img src={loadImage((learnerData.rank))} width="50rem"></img>
                                    </TableCell>
                                    <TableCell align="justify" sx={{ color: '#DB8829', fontSize: '0.75rem', fontWeight: '500', padding: '10px', '@media (min-width: 1636px)': { fontSize: '1.1rem' } }}>
                                        {learnerData.rank}
                                    </TableCell>
                                    <TableCell align="left" sx={{ color: '#DB8829', fontSize: '0.75rem', fontWeight: '600', padding: '10px', '@media (min-width: 1636px)': { fontSize: '1.1rem' } }}>
                                        {joinByKeys(learnerData.name, ['firstname', 'lastname'], ' ')}
                                    </TableCell>
                                    <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.75rem', fontWeight: '500', padding: '10px', '@media (min-width: 1636px)': { fontSize: '1.1rem' } }}>
                                        {learnerData.percentage} %
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                    </Table>
                )}
            </div>
        </>
    );
}
const useStyles = makeStyles({
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.6em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        },
    },
})
export default ClasswiseTopLearners;